import { render, staticRenderFns } from "./MatchPicker.vue?vue&type=template&id=8c8a5b1a&scoped=true"
import script from "./MatchPicker.vue?vue&type=script&lang=js"
export * from "./MatchPicker.vue?vue&type=script&lang=js"
import style0 from "./MatchPicker.vue?vue&type=style&index=0&id=8c8a5b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8a5b1a",
  null
  
)

export default component.exports